/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Measurements API
 * OpenAPI spec version: 1.0.0
 */
import {
  useApiData
} from 'react-api-data'
import type {
  HookOptions,
  Method
} from 'react-api-data'
import type {
  Delete,
  Measurement,
  PostMeasurement,
  PostUsers,
  ProcedureInLogin,
  ProcedureInLogout,
  ProcedureOutLogin,
  ProcedureOutLogout,
  Users
} from './types'


/**
 * Measurement
 * @summary Get all items in Measurement
 */
export const useGetMeasurement = (
    params: {}, options?: HookOptions 
) => useApiData<Measurement[], void, {}, unknown>('getMeasurement', params, options);

/**
 * Measurement
 * @summary Add item to Measurement
 */
export const usePostMeasurement = (
    params: {} = {}, options?: HookOptions 
) => useApiData<Measurement, void, {}, PostMeasurement>('postMeasurement', params, options);

/**
 * Measurement
 * @summary Get one items in Measurement
 */
export const useGetMeasurementIdMeasurement = (
    params: {idMeasurement: number}, options?: HookOptions 
) => useApiData<Measurement, void, {idMeasurement: number}, unknown>('getMeasurementIdMeasurement', params, options);

/**
 * Measurement
 * @summary Update one item in Measurement
 */
export const usePutMeasurementIdMeasurement = (
    params: Partial<{idMeasurement: number}> = {}, options?: HookOptions 
) => useApiData<Measurement, void, Partial<{idMeasurement: number}>, PostMeasurement>('putMeasurementIdMeasurement', params, options);

/**
 * Measurement
 * @summary Delete one item from Measurement
 */
export const useDeleteMeasurementIdMeasurement = (
    params: Partial<{idMeasurement: number}> = {}, options?: HookOptions 
) => useApiData<Delete, void, Partial<{idMeasurement: number}>, unknown>('deleteMeasurementIdMeasurement', params, options);

/**
 * Users
 * @summary Get all items in Users
 */
export const useGetUsers = (
    params: {}, options?: HookOptions 
) => useApiData<Users[], void, {}, unknown>('getUsers', params, options);

/**
 * Users
 * @summary Add item to Users
 */
export const usePostUsers = (
    params: {} = {}, options?: HookOptions 
) => useApiData<Users, void, {}, PostUsers>('postUsers', params, options);

/**
 * Users
 * @summary Get one items in Users
 */
export const useGetUsersIdUsers = (
    params: {idUsers: number}, options?: HookOptions 
) => useApiData<Users, void, {idUsers: number}, unknown>('getUsersIdUsers', params, options);

/**
 * Users
 * @summary Update one item in Users
 */
export const usePutUsersIdUsers = (
    params: Partial<{idUsers: number}> = {}, options?: HookOptions 
) => useApiData<Users, void, Partial<{idUsers: number}>, PostUsers>('putUsersIdUsers', params, options);

/**
 * Users
 * @summary Delete one item from Users
 */
export const useDeleteUsersIdUsers = (
    params: Partial<{idUsers: number}> = {}, options?: HookOptions 
) => useApiData<Delete, void, Partial<{idUsers: number}>, unknown>('deleteUsersIdUsers', params, options);

/**
 * Login
 * @summary Execute procedure Login
 */
export const usePostLogin = (
    params: {} = {}, options?: HookOptions 
) => useApiData<ProcedureOutLogin, void, {}, ProcedureInLogin>('postLogin', params, options);

/**
 * Logout
 * @summary Execute procedure Logout
 */
export const usePostLogout = (
    params: {} = {}, options?: HookOptions 
) => useApiData<ProcedureOutLogout, void, {}, ProcedureInLogout>('postLogout', params, options);

const getUrl = (path: string) => `${path}`;
export const endpointConfig = {
    getMeasurement: {
        url: getUrl('/api/v1/measurement'),
        method: 'GET' as Method,
    },
    postMeasurement: {
        url: getUrl('/api/v1/measurement'),
        method: 'POST' as Method,
    },
    getMeasurementIdMeasurement: {
        url: getUrl('/api/v1/measurement/:idMeasurement'),
        method: 'GET' as Method,
    },
    putMeasurementIdMeasurement: {
        url: getUrl('/api/v1/measurement/:idMeasurement'),
        method: 'PUT' as Method,
    },
    deleteMeasurementIdMeasurement: {
        url: getUrl('/api/v1/measurement/:idMeasurement'),
        method: 'DELETE' as Method,
    },
    getUsers: {
        url: getUrl('/api/v1/users'),
        method: 'GET' as Method,
    },
    postUsers: {
        url: getUrl('/api/v1/users'),
        method: 'POST' as Method,
    },
    getUsersIdUsers: {
        url: getUrl('/api/v1/users/:idUsers'),
        method: 'GET' as Method,
    },
    putUsersIdUsers: {
        url: getUrl('/api/v1/users/:idUsers'),
        method: 'PUT' as Method,
    },
    deleteUsersIdUsers: {
        url: getUrl('/api/v1/users/:idUsers'),
        method: 'DELETE' as Method,
    },
    postLogin: {
        url: getUrl('/api/v1/login'),
        method: 'POST' as Method,
    },
    postLogout: {
        url: getUrl('/api/v1/logout'),
        method: 'POST' as Method,
    },
};
